<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 122.88 122.07"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <path
      id="path349"
      d="m 46.548156,72.325239 a 45.189899,45.189899 0 0 1 -4.541743,2.005345 c -7.400859,2.795105 -13.297727,1.79449 -20.175922,3.433075 -8.342358,1.982843 -7.397767,10.788328 -3.600135,16.554596 a 32.476717,32.476717 0 0 0 7.320387,7.520725 39.076124,39.076124 0 0 0 8.046605,4.73653 c 19.793335,8.78134 33.16529,-2.92956 32.300308,-24.525243 A 13.814529,13.814529 0 0 0 65.562857,79.64373 19.208525,19.208525 0 0 1 46.548156,72.325239 Z"
      style="stroke-width:0.867202"
    />
    <path
      id="path347"
      d="m 57.569104,42.541031 c 0,-1.387523 0.112736,-2.783719 0.268833,-4.171242 0.867202,-7.865522 4.440074,-12.66115 6.070414,-19.52939 C 65.980964,10.506587 57.707856,7.3499718 50.848288,8.1131096 A 32.433357,32.433357 0 0 0 40.814761,11.209021 38.659867,38.659867 0 0 0 32.95791,16.221449 c -16.832392,13.632416 -12.479038,30.872393 7.128401,39.91731 a 12.687166,12.687166 0 0 0 3.260679,0.98861 19.182509,19.182509 0 0 1 14.222114,-14.586338 z"
      style="stroke-width:0.867202"
    />
    <path
      id="path345"
      d="m 79.908392,67.763379 c 0.94318,0.553382 1.877652,1.141443 2.779946,1.771303 6.520051,4.468903 9.040839,9.907199 14.304727,14.62891 6.381095,5.72213 13.080015,-0.05811 15.660345,-6.466758 a 32.407341,32.407341 0 0 0 2.01536,-10.299884 39.327613,39.327613 0 0 0 -0.69282,-9.299127 C 109.9485,36.789267 92.692836,32.481259 75.425824,45.503517 a 12.262237,12.262237 0 0 0 -1.966779,1.839604 19.078445,19.078445 0 0 1 6.373397,9.415384 v 0 a 19.139149,19.139149 0 0 1 0.03824,10.965048 z"
      style="stroke-width:0.867202"
    />
    <path
      id="path343"
      d="M 62.113243,46.348048 A 14.829155,14.829155 0 1 1 47.284088,61.177203 14.829155,14.829155 0 0 1 62.113243,46.348048 Z"
      class="secondary"
      style="stroke-width:0.867202"
    />
  </svg>   
</template>

<style lang="scss" scoped>
path {
   fill: $primary-color;
}
.secondary {
   fill: $secondary-color;
}
svg:hover {
   animation: spin 0.5s forwards;
}
@keyframes spin {
  
  33% {
    transform: rotate(-360deg);
  }
  
  66% {
    transform: rotate(-720deg);
  }
  
  100% {
    transform: rotate(-1080deg);
  }
  
}
</style>